module.exports = __webpack_public_path__ + "c9b8e5cac48a37413493700245c6fae6.svg";